import { render, staticRenderFns } from "./DistributorDeviceSideview.vue?vue&type=template&id=74073f1a&scoped=true&class=fill-height"
import script from "./DistributorDeviceSideview.vue?vue&type=script&lang=ts"
export * from "./DistributorDeviceSideview.vue?vue&type=script&lang=ts"
import style0 from "./DistributorDeviceSideview.vue?vue&type=style&index=0&id=74073f1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74073f1a",
  null
  
)

export default component.exports